var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg360(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 81.04 81.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "360") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.52,47.27C40.11,47.27,0,46.91,0,33.77c0-3.87,4.07-7.23,11.77-9.71a1.69,1.69,0,0,1,1,3.21c-7,2.24-9.43,4.83-9.43,6.5C3.38,40,25,43.9,40.52,43.9c13.33,0,37.14-3.39,37.14-10.13,0-2.1-3.35-4.48-9-6.37a1.69,1.69,0,1,1,1.08-3.2C79.08,27.34,81,31.14,81,33.77c0,13.14-40.11,13.5-40.52,13.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.52,81C20.88,81,0,76.3,0,67.53V33.77a1.69,1.69,0,1,1,3.38,0V67.53c0,4.23,14.13,10.13,37.14,10.13s37.14-5.9,37.14-10.13V33.77a1.69,1.69,0,0,1,3.38,0V67.53C81,76.3,60.16,81,40.52,81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.19,77.29a1.65,1.65,0,0,1-1.2-.5,1.7,1.7,0,0,1,0-2.39L22.75,62.75a4.44,4.44,0,0,1,6.33,0l6.73,6.42a1.07,1.07,0,0,0,.78.38,1.25,1.25,0,0,0,.83-.4l9.95-10.33a4.41,4.41,0,0,1,6.26-.23l16.7,14.72a1.69,1.69,0,1,1-2.23,2.53L51.36,61.1a1.07,1.07,0,0,0-1.58.09L39.84,71.5a4.52,4.52,0,0,1-3.22,1.43,4.12,4.12,0,0,1-3.17-1.34l-6.73-6.42a1,1,0,0,0-1.59,0L13.38,76.8a1.67,1.67,0,0,1-1.19.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.45,60.78a5.07,5.07,0,1,1,5.07-5.07,5.07,5.07,0,0,1-5.07,5.07Zm0-6.75a1.69,1.69,0,1,0,1.69,1.68A1.68,1.68,0,0,0,35.45,54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.84,44.4a1.68,1.68,0,0,1-1.68-1.69V35.25a1.69,1.69,0,1,1,3.37,0v7.46a1.68,1.68,0,0,1-1.69,1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.19,44.4a1.68,1.68,0,0,1-1.68-1.69V36.23a1.69,1.69,0,1,1,3.37,0v6.48a1.68,1.68,0,0,1-1.69,1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.21,30.39H37.14A3.38,3.38,0,0,1,33.77,27V13.51a3.38,3.38,0,0,1,3.37-3.38H43.9a1.69,1.69,0,0,1,0,3.38H37.14v5.06h5.07A3.38,3.38,0,0,1,45.58,22V27a3.38,3.38,0,0,1-3.37,3.38ZM37.14,22V27h5.07V22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.4,30.39H52.34A3.38,3.38,0,0,1,49,27V13.51a3.38,3.38,0,0,1,3.38-3.38H57.4a3.38,3.38,0,0,1,3.38,3.38V27a3.38,3.38,0,0,1-3.38,3.38ZM50.65,27h0Zm1.69,0H57.4V13.51H52.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27,30.39H22A1.69,1.69,0,1,1,22,27H27V22H22a1.69,1.69,0,0,1,0-3.38H27A3.38,3.38,0,0,1,30.39,22V27A3.38,3.38,0,0,1,27,30.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27,22H22a1.69,1.69,0,0,1,0-3.38H27V13.51H22a1.69,1.69,0,0,1,0-3.38H27a3.38,3.38,0,0,1,3.38,3.38v5.06A3.38,3.38,0,0,1,27,22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.22,10.13a5.07,5.07,0,1,1,5.07-5.07,5.07,5.07,0,0,1-5.07,5.07Zm0-6.75a1.69,1.69,0,1,0,1.69,1.68,1.69,1.69,0,0,0-1.69-1.68Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg360);
export default __webpack_public_path__ + "static/media/360.2233904a01298bafe804b4585abac553.svg";
export { ForwardRef as ReactComponent };